module.exports = __webpack_public_path__ + "static/media/user.cf69f127.png";